import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PromptOverride } from "@entities/generation-setting";

/**
 * 生成の上書き（本文と skip）を全置換する。
 *
 * 再生成で手元の調整を届ける口である。差分ではなく全置換なのは、同じタスクを 2 人が開いている
 * ときの競合解決を画面に持たせないためで、コンソールの生成結果ペインが使うのと同じ口である
 * （[[2026-08-17 設計ノート 生成結果レビューとプロンプト調整]]）。
 *
 * `baselineFingerprint` には差分を取った規定の写しの指紋を渡す。再生成では写しの持ち主は
 * **元タスク**で、作りたての新しいタスクはまだ自分の写しを持たない。引き継ぎ（`hand_over_overrides`）
 * も同じ理由で元の指紋を持ち越すので、そこへ揃える。写しが無ければ空文字でよい（サーバーは
 * 突き合わせを行わない）。
 */
export async function putTaskOverrides(
    projectId: string,
    taskId: string,
    prompts: Record<string, PromptOverride>,
    baselineFingerprint: string
): Promise<void> {
    const res = await fetchWithAuth(`/generation-overrides/${encodeURIComponent(taskId)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ projectId, baselineFingerprint, prompts }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "プロンプトの調整を保存できませんでした");
}
